import React from 'react';
import {getDeviceType, isMobileViewForTablet} from '../../utils/screenUtility';
import {DeviceType} from '../../constants/enums';

class MediaSelector extends React.Component {
    render() {
        const {devices = [], overrideCondition, children} = this.props;
        if (!children) {
            return null;
        }
        if (overrideCondition !== undefined) {
            if (overrideCondition) {
                return children;
            }
            return null;
        }

        if (devices.includes(DeviceType.Tablet) && isMobileViewForTablet()) {
            return null;
        }
        if (devices.includes(DeviceType.Mobile) && isMobileViewForTablet()) {
            return children;
        }
        if (devices.includes(getDeviceType())) {
            return children;
        }
        return null;
    }
}

export default MediaSelector;
